<template>
  <v-dialog
    v-model="isOpen"
    scrollable
    transition="slide-y-reverse-transition"
    persistent
    max-width="1000px"
  >
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>IMPORT PURCHASE ORDER</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn :disabled="saveLoading" icon @click="done">
            <v-icon>cancel</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-title class="font-weight-bold">Download Template</v-card-title>
            <v-card-text>
              <v-layout row>
                <v-flex xs4>
                  <v-select 
                    :items="brandList"
                    label="Choose Brand"
                    v-model="queryParams.brandName"
                    item-text="name"
                    item-value="name"
                    :hide-no-data="true"
                    class="mr-1"
                  ></v-select>
                </v-flex>
                <v-flex xs4>
                  <v-select 
                    :items="categoryList"
                    label="Choose Category"
                    v-model="queryParams.categoryName"
                    item-text="name"
                    item-value="name"
                    :hide-no-data="true"
                  ></v-select>
                </v-flex>
                <v-flex xs4 style="display: flex;">
                  <v-btn @click="downloadTemplate">
                    <v-icon left>get_app</v-icon>Excel Template
                  </v-btn>
              </v-flex>
            </v-layout>
            </v-card-text>
          </v-card>
          <v-card class="mt-1">
            <v-card-title class="font-weight-bold">
              Upload File
            </v-card-title>
            <v-card-text>
              <v-layout row>
                <v-flex xs5 pt-2>
                <input
                  type="file"
                  id="file"
                  ref="file"
                  v-on:change="onChangeFileUpload()"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                />
              </v-flex>
              <v-flex xs2 style="display: flex;">
                <v-btn @click="submitForm" :loading="saveLoading">
                  <v-icon left>cloud_upload</v-icon>Upload
                </v-btn>
              </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card>
            <span v-if="responseError" class="red--text">
              <ul style="list-style:none">
                <li v-for="res in responseError" :key="res">{{ res }}</li>
              </ul>
            </span>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { purchaseOrderService } from "../../services/purchase-order-service";
import { commonService } from "../../services/common-service";
import { brandService } from "../../services/brand-service";
import { categoryService } from "../../services/category-service";

export default {
  props: {
    isOpen: Boolean,
  },
  data: () => ({
    responseError: "",
    file: "",
    saveLoading: false,
    brandList: [],
    categoryList: [],
    findAll: { name: "ALL" },
    queryParams: {
      brandName: "",
      categoryName: "",
    }
  }),
  watch: {
    isOpen: function () {
      if (this.isOpen) {
        this.init();
        this.getBrandList();
        this.getCategoryList();
      }
    },
  },
  methods: {
    init: function () {
      this.responseError = "";
      this.$refs.file.value = "";
      this.file = "";
      this.queryParams.brandName = "ALL";
      this.queryParams.categoryName = "ALL";
    },
    done: function () {
      this.$emit("change");
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    downloadTemplate() {
      purchaseOrderService
        .getPurchaseOrderExcelTemplate(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          if (err.response) {
            this.responseError = err.response.data.message;
          }
        });
    },
    submitForm() {
      if (this.file) {
        this.saveLoading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        purchaseOrderService
          .savePurchaseOrderExcel(formData)
          .then((res) => {
            this.done();
            console.log(res.data);
          })
          .catch((err) => {
            if (err.response) {
              this.responseError = err.response.data.message.split(".");
              console.log(err.response.data);
            }
          })
          .finally(() => {
            this.saveLoading = false;
          });
      }
    },
    getBrandList(){
      brandService
        .getBrandsByStatus("ACTIVE")
        .then((res) => {
          this.brandList = res.data;
          this.brandList.splice(0,0,JSON.parse(JSON.stringify(this.findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCategoryList() {
      categoryService
        .getCategoriesByStatus("ACTIVE")
        .then((res) => {
          this.categoryList = res.data;
          this.categoryList.splice(0,0,JSON.parse(JSON.stringify(this.findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>